import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/main.tsx';
import tripRepository from '@/api/repositories/tripRepository/TripRepository.ts';
import type { Trip } from '$/models/Trip.model.ts';

const useTripUpdate = (refetch = true) => {
  const mutationFn = async (request: Parameters<typeof tripRepository.update>) => {
    return updateAction(...request);
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      if (refetch) {
        void queryClient.invalidateQueries({ queryKey: ['trips'] });
      }
    },
  });
};

export default useTripUpdate;

async function updateAction(...request: Parameters<typeof tripRepository.update>): Promise<Trip> {
  const { data, error } = await tripRepository.update(...request);

  if (error) throw new Error(error.message);

  return data;
}
